import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M9 .293l4.354 4.353-.708.708L9.5 2.207V15h-1V2.207L5.354 5.354l-.708-.708L9 .293zM18 16.5v1H0v-1h18z" /></svg>;